import { HoursOfOperationsDayType } from 'types/UFOTypes';

export const isHoursOfOperations = (
  maybeHoursOfOperations: unknown,
): maybeHoursOfOperations is HoursOfOperationsDayType => {
  if (typeof maybeHoursOfOperations !== 'object') return false;

  if (maybeHoursOfOperations === null) return true;

  if (!('begin' in maybeHoursOfOperations)) {
    return false;
  }

  if (!('end' in maybeHoursOfOperations)) {
    return false;
  }

  const { begin, end } = maybeHoursOfOperations as { begin: unknown; end: unknown };
  if (typeof begin !== 'string' || typeof end !== 'string') {
    return false;
  }

  return true;
};
